// cspell:words Actvity

import { EntitlementDto, getEntitlementName } from './entitlement.dto';

/**
 * Enumeration of all feature flags the application uses.
 */
export enum Feature {
    TransferActivityMinusSevenDays = 'TransferActivityMinusSevenDays',
    AchAllowUnbalancedPayments = 'Feature.ACH.AllowUnbalancedPayments',
    AchFilterManagement = 'Feature.PositivePay.ACHFilterManagement',
    CheckExceptionsDecisionActivity = 'checkExceptionsDecisionActivity',
    AchNotificationOfChangeNacha = 'Feature.ACH.NotificationOfChange.Nacha',
    AchReturnReviewNacha = 'Feature.ACH.Return.Nacha',
    AchSftpEnabled = 'Feature.Ach.Nacha.SFTP.DataTransmissions',
    AchTemplateSelectFromRecipientsList = 'AchTemplateSelectFromRecipientsList',
    AdditionalLoanDetails = 'Feature.Loan.PaymentDetails',
    ExcludeLoanLimitValidation = 'Feature.Loan.TM35475.ExcludeLoanPaymentLimitValidation',
    LoanPaymentsInterestOnly = 'Feature.LoanPayments.InterestOnly.TM2948',
    AgileticsEnabled = 'Feature.Product.EnableAgiletics',
    Analytics = 'MixPanelAnalytics',
    BoPositivePayPerformanceEnhancement = 'Feature.PositivePay.EnabledAccountsPerformance.3297',
    BoUserSearch = 'Feature.BackOffice.Uis.UserSearch',
    BoWireDetailCard = 'Feature.Wire.WireDetailCard',
    BrandTheme = 'Feature.BrandTheme',
    CheckExceptionV2 = 'Feature.PositivePay.CheckExceptionV2',
    CheckLookupWidget = 'CheckLookupWidget',
    CreateTransferTemplate = 'Create Template',
    CreateTransferPayment = 'Transfer, Create',
    DebugMode = 'DebugMode',
    EditProductFeature = 'Edit Product Feature',
    EulaText = 'Feature.Disclosure.EULA.TM28729',
    FdicDigitalSign = 'FdicDigitalSign',
    HasIssuedItemsClearedDate = 'Feature.AccountRecon.IssuedItems.AddClearedDateFilter.TM31553',
    ProcessXlsIssuedItemsFiles = 'Feature.Arp.ProcessXlsIssuedItemsFiles',
    IssuedItemsModification = 'Feature.PositivePay.IssuedItemModification.TM23310',
    IssuedItemSftpEnabled = 'Feature.Issued.Item.SFTP.DataTransmissions',
    IssuedItemsFileActivityUpdate = 'Feature.IssuedItem.IssuedItemFileActivityUpdate.TM39786',
    IssuedItemsFileActivityMenuOption = 'Feature.IssuedItem.IssuedItemFileActivityMenuOption.TM39786',
    IssuedItemsOdi = 'Feature.Arp.IssuedItemsViaOdi',
    IssuedItemsVoids = 'Feature.AccountRecon.IssuedItemVoids',
    HideAccountsWidgetGroupBalance = 'Feature.SupressGroupAvailBalance.AccountWidget',
    LitDomesticAch = 'Feature.ACH.DomesticPayments',
    MessageCenterEnhancement = 'Feature.MessageCenterEnhancement',
    MobileDeposits = 'MobileDeposits',
    NewBoWireDetail = 'Feature.Wire.NewWireDetail',
    PositivePayCheckExceptionAttachments = 'Feature.PositivePay.CheckException.Attachments',
    PositivePayReturnReason = 'Feature.PositivePay.ReturnReason',
    TransmitReturnReasonCode = 'Feature.TransmitReturnReasonCode.TM-35519',
    UisEnabled = 'Feature.Authentication.UIS',
    UisSecurityLevel = 'Feature.IdentitySettings.UisSecurityLevel',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    UisResetPassword = 'Feature.Authentication.UIS',
    WausauStatementsEnabled = 'FODWausauStatements',
    BdiEStatementsEnabled = 'BdiEStatements',
    WidgetCreateAchFilterRuleButton = 'WidgetCreateAchFilterRuleButton',
    WireCreditorIsoSpeedBump = 'Feature.Wire.BeneficiarySpeedbump.ISO20022',
    WireSftpEnabled = 'Feature.Wire.SFTP.DataTransmissions',
    MixPanelProxy = 'mix-panel-proxy',
    AccountSuperUserEntitlements = 'Feature.Account.SuperUserEntitlements.TM25159',
    ChannelUseAccountNameTM6777 = 'Feature.Channel.UseAccountName.TM6777',
    SsoNavigations = 'sso-navigations',
    SaveTransferAsTemplate = 'SaveTransferAsTemplate',
    StopPaymentApproveOrReject = 'Approve Stop Payment',
    Copyright = 'Copyright',
    MemberNCUA = 'MemberNCUA',
    AccountIncludeInterestDetails = 'Feature.Account.AccountInquiry.IncludeInterestDetails',
    /**
     * Indicates that the server is using the modern .NET Core SignalR implementation.
     */
    ModernRealtime = 'net-core-signal-r',
    UseJhWires = 'use-jh-wires',
    // PWA feature flags
    PwaMigration = 'pwa-migration',
    IsPwaBetaBank = 'IsPwaBetaBank',
    RemoteDepositManualCapture = 'Feature.PWA.RemoteDepositManualCapture',
    PwaAdminSection = 'AdminSection',
    PwaConfigureDashboard = 'ConfigureDashboard',
    PwaDashboardManageAccounts = 'ManageAccountGroups',
    PwaGetCameraPermission = 'PwaGetCameraPermission',
    PwaMitekPreload = 'PwaMitekPreload',
    PwaPaymentHub = 'PaymentHub',
    PwaCreateSingleWireManual = 'PwaCreateSingleWireManual',
    PwaWireFileActivity = 'WireFileActivity',
    PwaWireTemplatesList = 'WireTemplatesList',
    PwaWireEditCreditor = 'WiresEditCreditor',
    PwaWireMultipleWorkflow = 'WireMultipleWorkflow',
    PwaWireFx = 'WireFx',
    PwaCorpaySso = 'CorpaySso',
    PwaWireFxHideQuoteRestrictionInfo = 'Feature.FxWire.HideQuoteRestrictionInformation',
    PwaAccountResearchTransactions = 'AccountResearchTransactions',
    ArpUploadFormats = 'ArpUploadFormats',
    ArpOutputFiles = 'ArpOutputFiles',
    AchFileActivity = 'AchFileActivity',
    AchNoticeOfChange = 'AchNoticeOfChange',
    PwaAgileticsWebEscrow = 'AgileticsWebEscrow',
    PwaAchMasterRecipients = 'AchMasterRecipients',
    PwaAchRecipientActivity = 'AchRecipientActivity',
    PwaAchReturnActivity = 'AchReturnActivity',
    PwaAchTemplatesList = 'AchTemplatesList',
    PwaAchChildSupport = 'PwaAchChildSupport',
    PwaAchPaymentTypeSelector = 'PwaAchPaymentTypeSelector',
    PwaAchTaxPayments = 'PwaAchTaxPayments',
    PwaAchImportLayout = 'AchImportLayout',
    PwaAchInternationalTemplates = 'AchInternationalTemplates',
    PwaTransferTemplatesList = 'TransferTemplatesList',
    PwaTransferTemplateWorkflow = 'TransferTemplateWorkflow',
    PwaStopPayments = 'StopPaymentActivity',
    PwaStopPaymentsWorkflow = 'StopPaymentsWorkflow',
    PwaNotificationPreferences = 'NotificationPreferences',
    PwaTransferPaymentWidget = 'TransferPaymentWidget',
    PwaMessageCenterAdvancedFilters = 'MessageCenterAdvancedFilters',
    PwaRouteToLegacyChannel = 'RouteToLegacyChannel',
    PwaAddAnotherTransfer = 'AddAnotherTransfer',
    PwaDashboardFeatureSearch = 'DashboardFeatureSearch',
    PwaWireFileUpload = 'WireFileUpload',
    ManualCaptureFISetting = 'ManualCaptureFISetting',
    PwaElectronicDocuments = 'ElectronicDocuments',
    PwaReportsMenuItem = 'PwaReportsMenuItem',
    AccountReconReporting = 'AccountReconReporting',
    ArpIssuedItemsActivity = 'ArpIssuedItemsActivity',
    ArpIssuedItemsFileActivity = 'ArpIssuedItemsFileActivity',
    ArpIssuedItemsCreate = 'ArpIssuedItemsCreate',
    BoV2Reports = 'Feature.BackOffice.V2.Reports',
    CoBrowse = 'co-browse',
    CentrixSso = 'CentrixSso',
}

export interface FeatureUser {
    userId: string;
    companyId?: string;
    isAdmin: boolean;
    isSuperUser: boolean;
}
/**
 * The shape of the data specified in the local `feature-flags.json` file.
 *
 * The key is the feature name.
 * The value is a binary on/off boolean or a whitelist of FI IDs to enable it for.
 */
export type LocalFeatureJson = Record<Feature, boolean | string[]>;

export enum TmFeatureType {
    /**
     * Represents the state of a Treasury Management BSL entitlement-based feature.
     */
    Entitlement,
    /**
     * Represents the state of a Treasury Management local UI-defined feature.
     */
    Local,
    /**
     * Represents the state of a Launch Darkly-defined feature flag.
     */
    LaunchDarkly,
}
export interface TmFeatureFlag {
    readonly type: TmFeatureType;
    readonly enabled: boolean;
    readonly name: Feature;
}

export interface FeatureChangedPayload {
    featureName: Feature;
    enabled: boolean;
}

export class EntitlementFeatureFlag implements TmFeatureFlag {
    constructor(
        private dto: EntitlementDto,
        public readonly enabled = true
    ) {}

    public readonly type = TmFeatureType.Entitlement;

    public readonly name = getEntitlementName(this.dto) as Feature;
}
